import React from "react";
import { useI18n } from "../i18n";
import { MENU_IMAGES } from "../constants";

const images = MENU_IMAGES;

export default function MenuSection() {
  const { t } = useI18n();

  return (
    <section
      id="menu"
      className="relative py-24 md:py-32 border-t border-[#2d2622]"
      data-testid="menu-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="divider-gold" />
            <span className="overline">{t.menu.overline}</span>
          </div>
          <h2
            className="font-serif-display text-4xl sm:text-5xl md:text-6xl font-light leading-tight text-[#f4f0eb]"
            data-testid="menu-title"
          >
            {t.menu.title}
          </h2>
          <p className="mt-6 text-[#a39e97] text-base md:text-lg leading-relaxed">
            {t.menu.subtitle}
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 border-t border-[#2d2622]">
          {t.menu.items.map((item, idx) => (
            <article
              key={idx}
              className="group relative border-b border-r border-[#2d2622] last:border-r md:[&:nth-child(2n)]:border-r-0 lg:[&:nth-child(2n)]:border-r lg:[&:nth-child(3n)]:border-r-0 p-8 md:p-10 bg-[#121110] hover:bg-[#1a1715] transition-colors duration-500"
              data-testid={`menu-item-${idx}`}
            >
              <div className="aspect-[4/3] overflow-hidden mb-6">
                <img
                  src={images[idx % images.length]}
                  alt={item.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
              </div>

              <div className="text-[10px] uppercase tracking-[0.28em] text-[#d4af37] mb-3">
                {item.tag}
              </div>
              <h3 className="font-serif-display text-2xl md:text-3xl text-[#f4f0eb] font-normal leading-snug">
                {item.name}
              </h3>
              <p className="mt-4 text-[#a39e97] text-sm md:text-base leading-relaxed">
                {item.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
